// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page-wrapper {
  padding: var(--spacing-extra-big);
}
.profile-page-wrapper .profile-page-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
}
.form-delivery-address-personal {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
}
.container-state-delivery-address {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.company-data-50-percent-container {
  width: 50%;
}
.company-data-container-documento-state-inscription {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--spacing-small);
}
.form-company-data {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
}
.personal-data-container-state-inscription {
  width: 33%;
}
.personal-data-container-ie-document-birth {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-small);
}
.personal-data-container-width-100 {
  width: 100%;
}
.form-personal-data {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/profile/ProfileStyles.less"],"names":[],"mappings":"AAAA;EACE,iCAAA;AACF;AAFA;EAII,aAAA;EACA,sBAAA;EACA,2BAAA;AACJ;AAGA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AADF;AAIA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAFF;AAKA;EACE,UAAA;AAHF;AAMA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;AAJF;AAOA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AALF;AAQA;EACE,UAAA;AANF;AASA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAPF;AAUA;EACE,WAAA;AARF;AAWA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AATF","sourcesContent":[".profile-page-wrapper {\n  padding: var(--spacing-extra-big);\n\n  .profile-page-content {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-regular);\n  }\n}\n\n.form-delivery-address-personal {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-regular);\n}\n\n.container-state-delivery-address {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.company-data-50-percent-container {\n  width: 50%;\n}\n\n.company-data-container-documento-state-inscription {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: var(--spacing-small);\n}\n\n.form-company-data {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-regular);\n}\n\n.personal-data-container-state-inscription {\n  width: 33%;\n}\n\n.personal-data-container-ie-document-birth {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-small);\n}\n\n.personal-data-container-width-100 {\n  width: 100%;\n}\n\n.form-personal-data {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-regular);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
